import { memo } from "react"

import { noop } from "shared/lib/noop"
import { Checkbox } from "shared/ui/input/select/checkbox/Checkbox"

interface ProductPositionRowSelectionCellProps {
  isSelected: boolean
  label: string
}

/**
 * A leading checkbox cell rendered inside a product-position table row when
 * the table opts into `showSelectionCheckbox`.
 *
 * The checkbox is a visual indicator of the row's selection state. Because it
 * lives inside the `role="row"` element, a click on it bubbles to the row's own
 * click handler, which drives selection through the table's selection model —
 * so there is a single toggle handler and no double-toggle. `onChange` is a
 * no-op to keep the controlled input from warning; `tabIndex={-1}` keeps it out
 * of the tab order (row-level keyboard handling owns selection).
 * `stopClickPropagation={false}` lets the click bubble to the row handler.
 */
export const ProductPositionRowSelectionCell = memo(
  ({ isSelected, label }: ProductPositionRowSelectionCellProps) => (
    <div
      role="gridcell"
      className="table-row-cell product-position-table__selection-cell"
    >
      <Checkbox
        value={isSelected}
        onChange={noop}
        tabIndex={-1}
        aria-label={label}
        stopClickPropagation={false}
      />
    </div>
  )
)

ProductPositionRowSelectionCell.displayName = "ProductPositionRowSelectionCell"
